<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('PROFILE.HEADER') }}
    </h1>
    <h1 class="headline-sub text--center">
      {{ this.$i18n.t('PROFILE.INFO') }}
    </h1>
    <list-link
      to="passwordChange"
      :label="this.$i18n.t('PROFILE.PASSWORD_CHANGE')"
    />
    <list-link
      to="emailChange"
      :label="this.$i18n.t('PROFILE.EMAIL_CHANGE')"
    />
    <marketing-checkbox />
    <submit-button
      id="profileSubmitButton"
      :label="this.$i18n.t('PROFILE.LOGOUT')"
      :on-click="logout"
    />
  </narrow-container>
</template>

<script>
import MarketingCheckbox from '@/views/profile/MarketingCheckbox.vue';

export default {
  name: "Profile",
  components: {  MarketingCheckbox },
  data: function() {
    return {
      inProgress: false,
    };
  },
  methods: {
    logout: function() {
      this.inProgress = true;
      // try to remove token on server
      this.$http.delete('api/accessToken', null).finally(
        () => {
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Logout',label: 'Success', value: 0, noninteraction: false });
          this.inProgress = false;
          // whatever the result is, delete token locally
          this.$store.commit("clearAllStoreData")
          this.$router.push({name: 'landing'});
        })
      }
  }
}
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
